<template>  
    <section class="blockElement">
        <div class="container-fluid">
            <div class="innerInclude">
                <div class="p_login">
                    <div class="row">
                        <div class="col-12 col-md-4 text-center d-flex vh_100 align-items-center blueBG beforeBG">
                            <div class="titleArera Loginlogo">
                                <img src="../../../../static/fxView/images/fxview_logo_white.svg" alt="fxView">
                            </div>
                            <div class="PortfoliosTitle"> 
                                <div id="demo" class="carousel slide fxRegisterSteps " data-ride="carousel"> 
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <!-- <p>{{ $t('welcomeMsg') }}</p> -->
                                            <img src="../../../../static/fxView/images/login_trading_platform.svg" alt="Banner">
                                            <h3>{{$t('welcomeMsgHeadone')}}</h3>
                                            <p>{{$t('welcomeMsg1')}}</p>       
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../../../../static/fxView/images/login_trader_toolbox.svg" alt="Banner">
                                            <h3>{{$t('welcomeMsgHeadtwo')}}</h3>
                                            <p>{{$t('welcomeMsg2')}}</p>
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../../../../static/fxView/images/login_download_platform.svg" alt="Banner">
                                            <h3>{{$t('welcomeMsgHeadthree')}}</h3>
                                            <p>{{$t('welcomeMsg3')}}</p>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <ul class="carousel-indicators mt-3">
                                        <li data-target="#demo" data-slide-to="0" class="active"></li>
                                        <li data-target="#demo" data-slide-to="1"></li>
                                        <li data-target="#demo" data-slide-to="2"></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-8 d-flex vh_100 align-items-center">
                            <!--loader - message--->
                            <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                            
                            <div class="sign_insec">
                                <div class="subtitle">
                                    <h3> {{$t('resetPassword')}}</h3>
                                    <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                                </div>
                                <div class="stepForm" v-show='displayMessage'>
                                    <p>{{$t('passwordHashMsz2')}}  <router-link to="/">  {{$t('here')}} </router-link>{{$t('toLogin')}}</p>
                                </div> 
                                <div class="stepForm" v-show='!displayMessage'>
                                    <div class="form-group field-wrapper">
                                        <input :type="inputtype" placeholder=" " v-model="password" class="float-field form-control" v-validate="{ required: true ,regex : /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!@#$%^&*])\S{6,24}$/ , is: confirmPassword }" name="password" :class="{ 'is-invalid': submitted && errors.has('password') }" ref="passwordInput" >
                                        <label for="password" class="float-label"> {{$t('password')}}</label>
                                        <feather :type="iconType" class="toggle-password" @click="switchVisibility('1')"></feather> 
                                        <p class="error" v-for="error in errors.collect('password')">
											<span v-show="error == 'The password field is required.'">{{$t('passwordFieldReq')}}</span>
											<span v-show="error == 'The password field format is invalid.'">Your password must contain at least 6 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^*)</span>
										</p>
                                    </div> 
                                    <div class="form-group field-wrapper">
                                        <input :type="inputtype1" placeholder=" " v-model="confirmPassword" class="float-field form-control" v-validate="'required'" name="confirmPassword" :class="{ 'is-invalid': submitted && errors.has('confirmPassword') }" ref="confirmPasswordInput" >
                                        <label for="password" class="float-label">  {{$t('conPassword')}}</label>
                                        <feather :type="iconType1" class="toggle-password" @click="switchVisibility('2')"></feather> 
                                    </div> 
                                    <div class="clearfix"></div>
                                    <div class=" d-flex justify-content-between align-items-center submitButton">
                                        <button class="prism_btn btn_sm" v-on:click="submit()"> {{$t('resetPassword')}}</button>
                                        <div class="forgot_sec">
                                            <router-link :to="'/'" class="forgotpassword d-flex">
                                                <feather type="chevron-left" class="mr-1"></feather>{{$t('backLogin')}} 
                                            </router-link>     
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-5 contactsupport border-top pt-3 text-center">
                                    <h4 class="mb-3"> {{$t('otherWayHelp')}}</h4>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <div class="text-center">
                                            <router-link to="#" class="btn_sm grd_btn"> {{$t('chatWithUs')}}</router-link>
                                        </div>
                                        <div class="text-center mx-3">
                                             {{$t('or')}}
                                        </div>
                                        <div class="text-center">
                                            <router-link to="#"  class="btn_sm grd_btn"> {{$t('callUs')}}</router-link>
                                        </div>
                                    </div>
                                </div>            

                                
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import i18n from '@/plugins/lang/i18n';
    export default {
        name: 'Forgot-password',
        data() {
            return {
                "password" : "",
                "confirmPassword":"",
                submitted: false,
                inputtype1: 'password',
                inputtype: 'password',
                iconType : 'eye-off',
                iconType1 : 'eye-off',
                showpassword: false,
                showpassword1: false,
                displayMessage: false,
                pageLoader : false,
                response_msg : '',
                msg_type : '',
            }
        },
        methods:{
            ...mapActions({
                _runResetPasswordFromHash: types.RUN_USER_RESET_PASSWORD_FROM_HASH
            }),
            switchVisibility(getData) {
                if(getData == '1'){
                    this.showpassword = !this.showpassword
                    if(this.showpassword){
                        this.inputtype = 'text'
                        this.iconType = 'eye'
                    }else{
                        this.inputtype = 'password'
                        this.iconType = 'eye-off'
                    } 
                }else{
                    this.showpassword1 = !this.showpassword1
                    if(this.showpassword1){
                        this.inputtype1 = 'text'
                        this.iconType1 = 'eye'
                    }else{
                        this.inputtype1 = 'password'
                        this.iconType1 = 'eye-off'
                    } 
                }
                
            },
            submit(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                "password": _that.password,
                                "cpassword": _that.confirmPassword,
                                "hash": _that.hash

                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runResetPasswordFromHash(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        },
        created(){
			this.hash = this.$route.params.hash
            //this.hash = this.$route.params.hash
            // console.log(params)            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/ResetPasswordFromHash.vue